import { Form, Row } from 'antd';
import React from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import DatePickerComponent from 'components/atoms/DatePickerComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import FormWrapper from 'components/molecules/FormWrapper';

import { useDateLimit } from 'hooks/statniSprava/useDateLimit';
import { useFormBasics } from 'hooks/statniSprava/useFormBasics';

import prblSelect from 'data/codebooks/statniSprava/prblSelect';

import numberValidation from 'utils/validations/numberValidation';
import pismenaCislaValidation from 'utils/validations/pismenaCislaValidation';
import { rcmaValidationSimple } from 'utils/validations/rcmaValidation';

import AlertComponent from './AlertComponent';
import OdeslaniPozadavkuRows from './odeslaniPozadavkuRows';

interface IF20 {}

const F20: React.FC<IF20> = () => {
    const [form] = Form.useForm();
    const [, dateLoading, commonDisabledDate] = useDateLimit();

    const [
        errMsg,
        currentStep,
        idSluzby,
        upozorneni,
        loading,
        odeslaniResp,
        setErrMsg,
        prev,
        onFormSubmit,
        showPxKlicLoadingMsg
    ] = useFormBasics();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (fieldsValue: any) => {
        const dataToSend = {
            ...fieldsValue,
            dtod: fieldsValue.dtod.format('YYYY-MM-DD'),
            dtdo: fieldsValue.dtdo.format('YYYY-MM-DD')
        };
        onFormSubmit(dataToSend);
    };

    return (
        <LoadingWrapper loading={loading} loadingText={showPxKlicLoadingMsg ? 'LOADING_PXKLIC' : 'NACITANI'}>
            <Title level={4} text="DUVERNE_INFO_TITLE_F20" />
            {errMsg ? (
                <>
                    <Paragraph text={errMsg} />
                    <Row>
                        <ButtonComponent
                            id="f20ZpetBtn"
                            type="default"
                            buttontext="ZPET"
                            onClick={() => setErrMsg('')}
                        />
                    </Row>
                </>
            ) : (
                <>
                    {currentStep !== 2 ? (
                        <FormWrapper onFinish={onFinish} outForm={form}>
                            <>
                                <LoadingWrapper loading={dateLoading}>
                                    <DatePickerComponent
                                        name="dtod"
                                        label="ME_POZADAVKY_DATUM1"
                                        disabled={currentStep > 0}
                                        disabledDate={current =>
                                            current > form.getFieldValue('dtdo') || commonDisabledDate(current)
                                        }
                                    />
                                    <DatePickerComponent
                                        name="dtdo"
                                        disabled={currentStep > 0}
                                        label="ME_POZADAVKY_DATUM2"
                                        disabledDate={current =>
                                            current < form.getFieldValue('dtod') || commonDisabledDate(current)
                                        }
                                    />
                                </LoadingWrapper>
                                <InputComponent
                                    disabled={currentStep > 0}
                                    label="ME_POZADAVKY_CISLO_JEDNACI"
                                    name="actn"
                                    maxLength={30}
                                    type="text"
                                />

                                <InputComponent
                                    disabled={currentStep > 0}
                                    label="ME_POZADAVKY_IDIC_MAJITEL2"
                                    name="idmb"
                                    rules={pismenaCislaValidation()}
                                    type="text"
                                    maxLength={50}
                                />
                                <InputComponent
                                    label="ME_POZADAVKY_PREDCISLI_UCTU"
                                    name="cdac"
                                    type="text"
                                    maxLength={4}
                                    rules={numberValidation()}
                                    notRequired={true}
                                    disabled={currentStep > 0}
                                />
                                <InputComponent
                                    label="CISLO_UCTU"
                                    name="rcma"
                                    notRequired={true}
                                    type="text"
                                    maxLength={12}
                                    rules={rcmaValidationSimple()}
                                    disabled={currentStep > 0}
                                />
                                <SelectComponent
                                    name="prbl"
                                    labelParagraph="ME_POZADAVKY_KATEGORIE_TYP"
                                    labelCol={{
                                        span: 8
                                    }}
                                    data={prblSelect}
                                    isFormItem={true}
                                    disabled={currentStep > 0}
                                    defaultValue={prblSelect[0].value}
                                />
                                {currentStep === 0 && (
                                    <ButtonComponent
                                        id="f20OdeslatBtn"
                                        buttontext="ODESLAT"
                                        onClick={() => form.submit()}
                                    />
                                )}
                                {currentStep !== 0 && upozorneni && (
                                    <AlertComponent
                                        upozorneni={upozorneni}
                                        type={currentStep === 1 ? 'error' : 'info'}
                                    />
                                )}
                                {currentStep === 1 && (
                                    <Row className="button-row">
                                        <ButtonComponent
                                            id="f20ZpetAltBtn"
                                            buttontext="ZPET"
                                            onClick={() => prev()}
                                            type="default"
                                        />
                                        <ButtonComponent
                                            id="f20PotvrditBtn"
                                            buttontext="POTVRDIT"
                                            onClick={() => form.submit()}
                                        />
                                    </Row>
                                )}
                            </>
                        </FormWrapper>
                    ) : (
                        <>
                            <OdeslaniPozadavkuRows idSluzby={idSluzby} datum={odeslaniResp?.datum} />
                            {upozorneni && <AlertComponent upozorneni={upozorneni} type={'info'} />}
                        </>
                    )}
                </>
            )}
        </LoadingWrapper>
    );
};

export default F20;
